// extracted by mini-css-extract-plugin
export default {"textBlue":"LeadershipRegisterBanner_textBlue__61Axu","textPrime":"LeadershipRegisterBanner_textPrime__-cIb1","register":"LeadershipRegisterBanner_register__mDJma"};